
export const IDENT_DATA_SELECTION = "data_selection"
export const IDENT_FILTER_SELECTION = "filter_selection"
